import * as server_py from './server.py'

export default [server_py]
